<form class="row mx-0 px-0 h-100 w-100 d-flex justify-content-center align-items-start" [formGroup]="informationForm"
      (ngSubmit)="isValid()">
  <div class="col-12 mb-5 text-center">
    <h4>{{informationForm['id'] ? 'Edición ' : 'Creación '}}de Información
    </h4>
  </div>
  <div *ngIf="!existsSubtitle &&!informationData['onlyImage']" class="col-12 mb-1 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Título</mat-label>
      <textarea #content formControlName="title" matInput [maxLength]="maxLength" placeholder="Ingresar título..." type="text"></textarea>
      <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
    </mat-form-field>
  </div>

  <div *ngIf=" existsSubtitle && !informationData['onlyImage']" class="col-12 mb-1 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Título</mat-label>
      <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
    </mat-form-field>
  </div>
  <div *ngIf="existsSubtitle && !informationData['onlyImage']" class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Subtitulo</mat-label>
      <textarea #content formControlName="subTitle" [maxlength]="maxLength" matInput placeholder="Ingresar subtitulo..." type="text"></textarea>
      <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
    </mat-form-field>
  </div>
  <div *ngIf="informationData['hasOrderId']" class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Orden</mat-label>
      <input formControlName="orderId" matInput placeholder="1,2,3..." type="number"/>
    </mat-form-field>
  </div>
  <div *ngIf="informationData['onlyImage']" class="col-12 vs-outline-editCard h-fit-content mx-1">
    <img class="given-img" [src]="fileImg64 || informationData['img']" alt="img-benefit-slide"
         *ngIf="fileImg64 || informationData['img']">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-upload" class="custom-file-upload mt-5">
        <mat-icon>{{fileImg64 || informationData['img'] ? '': 'image'}} </mat-icon>
        <span class="my-2 text-center">{{informationData['img'] || fileImg64 ? 'Editar ' : 'Agregar'}}
          imagen de información</span>
      </label>
      <input id="file-upload" type="file" accept="image/*" (change)="getBase64($event)"/>
    </div>
  </div>
  <button type="submit" class="vs-btn-blue mt-3" [disabled]="informationForm.invalid">
    {{informationData && informationData['id'] ? 'Editar ' : 'Crear '}}
    información
  </button>
</form>
